import {DeviceList} from "../../data/data-class/devices/deviceListClass";
import {DeviceDetail} from "../../data/data-class/devices/deviceListClass";
import ViaqTryCatch from "../../services/GlobalTryCatch";
import axiosInstance from "../../services/axios";

class DeviceListRepository {
    static async getDevicesList(text, pageNumber,listLimit, id ) {
        const data = {
            text: text.trim(),
            pagenumber: pageNumber,
            limit: listLimit
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/device", data)
            });

        if (response.success) {
            const List = response.data.DeviceList.map(
                (device) =>
                    new DeviceList(
                        device.serialNumber,
                        device.modelName,
                        device.deviceName,
                        device.name,
                        device.phoneNumber.replace("+98", "0"),
                        device.status,
                        device.id
                    )
            );
            const all = response.data.countAll;
            return {
                DeviceList_data: List,
                countAllPages: all,
                code: response.statusCode,
                message: response.message,
            };
        }
        return {
            code: response.statusCode,
            message: response.message,
        };

    }

    static async delete(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/device/delete", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }
}

class DeviceLogRepository {
    static async getLogDevice(data) {
        //   const data = {
        //     "text":text,
        //     "pagenumber":pagenumber,
        //     "id":id
        // }
        // const logs_data = await postRequestWithToken("/device/log", data);
        // const deviceLogList = logs_data.data.logs.map(
        //   (log) => new DeviveLog(log.date, log.text)
        // );
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/device/log", data)
            });
        const code = response.statusCode;
        const message = response.message;
        if (response.success) {
            const countAll = response.data.countAll;
            const serialnumber = response.data.serialNumber;
            return {
                // deviceLogList,
                CountAllPages: countAll,
                SerialNumber: serialnumber,
                code,
                message,
            };
        }
        return {
            code,
            message,
        };
    }
}

class DeviceDetailRepository {
    static async getdeviceDetail(id_page) {
        const data = {
            id_page: id_page,
        };

        // const Device = await postRequestWithToken("/device/detail", data);
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/device/detail", data)
            });

        const code = response.statusCode;
        const message = response.message;
        if (response.success) {
            const Device_data = response.data.detail;
            const guest = Device_data.gues.map(
                (guest) =>
                    new DeviceDetail(guest.guestid, guest.guestname, guest.guestNumber)
            );
            return {
                code,
                message,
                detail: Device_data,
                guest

            };

        }

        return {
            code,
            message,
        };


    }

    static async deleteDevice(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/device/delete", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }

    static async getdeleteBroker(id) {
        const data = {
            id: id,
        };
        const response = await ViaqTryCatch(
            function () {
                return axiosInstance.post("/device/kick", data)
            });
        const code = response.statusCode;
        const massage = response.message;
        return {
            code,
            massage,
        };
    }
}

export {DeviceLogRepository};
export {DeviceListRepository};
export {DeviceDetailRepository};
